import React, { useState, useContext, useEffect } from 'react';
import useFetch from 'use-http';
import { IAppContextState } from 'src/reducers/AppContext';
import { AppContext } from 'src/providers/AppContextProvider';
import Dialog from 'src/components/common/Dialog.redesign';
import Button from 'src/components/controls/forms/redesign/FormButton';
import Landman from 'src/models/Landman';
import ProjectStaff from 'src/models/ProjectStaff';
import Project from 'src/models/Project';
import ProjectWorkClassification from 'src/models/ProjectWorkClassification';

interface IRemoveLandmanDialogProps {
    projectStaff: ProjectStaff;
    landman: Landman;
    workClassifications: ProjectWorkClassification[];
    onCloseDialog?: () => void;
    deStaffedListener?: (data: boolean) => void;
}

const RemoveLandmanDialog = (props: IRemoveLandmanDialogProps) => {
    const { get, del, response } = useFetch();
    const appContext = useContext<IAppContextState>(AppContext);

    const [projectName, setProjectName] = useState('');

    useEffect(() => {
        getProjectName();
    }, []);

    const getProjectName = async () => {
        let data: Project = await get(`v1.0/clients/${appContext.clientNumber}/Projects/${appContext.projectNumber}`);

        if (response.ok) {
            setProjectName(data.name);
        } else {
            console.log('Unable to get Project Name');
        }
    };

    const handleSubmitAction = () => {
        deleteProjectStaff(props?.projectStaff);
        props.onCloseDialog();
    };

    const handleCancelAction = () => {
        props.onCloseDialog();
    };

    const staffWorkClassification = () => {
        return props?.workClassifications
            ? props.workClassifications
                  .filter((wc) => wc.id === props?.projectStaff?.workClassificationId)
                  .map((wc) => {
                      return `${wc.name}`;
                  })
            : '';
    };

    const deleteProjectStaff = async (data: ProjectStaff) => {
        console.log('landman de-staffed to the project', data);
        await del(`v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/projectstaff/staffing/${data.id}`);

        if (response.ok) {
            props.deStaffedListener(true);
        }
    };

    return (
        <Dialog title="De-Staffing Landman">
            <h3>Confirm the next action:</h3>
            <div style={{ margin: '3rem 0', textAlign: 'center' }}>
                <p>{`De-Staffing ${staffWorkClassification()}: "${props?.landman?.firstName} ${
                    props?.landman?.lastName
                }" from Project: "${projectName}" `}</p>
            </div>
            <div style={{ display: 'flex', gap: '2rem' }}>
                <Button text="Submit" intent="primary" onClick={handleSubmitAction} />
                <Button text="Cancel" onClick={handleCancelAction} />
            </div>
        </Dialog>
    );
};

export default RemoveLandmanDialog;



// WEBPACK FOOTER //
// ./src/components/project/sections/RemoveLandmanDialog.tsx